__turbopack_context__.v({
  "default": "anchor-module-scss-module__KXzGnq__default",
  "responsive-image": "anchor-module-scss-module__KXzGnq__responsive-image",
});
